// extracted by mini-css-extract-plugin
export var component = "OctanyModule-module--component--ZN8Gc";
export var text = "OctanyModule-module--text--soc8Q";
export var wrapper = "OctanyModule-module--wrapper--S-Y3W";